import { Builder } from '@builder.io/react';
import {Button} from '@material-ui/core'

Builder.registerComponent(Button, {
  name: 'Button',
  // Optionally give a custom icon (image url - ideally a black on transparent bg svg or png)
  // image:'https://image-icon.svg',
  inputs: [
    {
      name: 'children',
      type: 'string',
      defaultValue: 'Button name'
    },
    {
      name: 'variant',
      type: 'string',
      defaultValue: 'contained',
      enum: ['text', 'outlined', 'contained']
    },
    {
      name: 'color',
      type: 'string',
      defaultValue: 'default',
      enum: ['default', 'inherit', 'primary', 'secondary']
    },
    {
      name: 'size',
      type: 'string',
      defaultValue: 'medium',
      enum: ['small', 'medium', 'large']
    },
    {
      name: 'disabled',
      type: 'boolean',
      defaultValue: false,
    },
    
  ]
});
